import { Component, OnInit } from "@angular/core";
import { AppointmentService } from "../../appointment-service/appointment.service";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";
import { take } from "rxjs/operators";
import { ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { AppontmentlocalService } from "../../appointment-service/appontmentlocal.service";
import { DoctorsService } from "src/app/doctor-section/doctor-service/doctors.service";

@Component({
  selector: "app-appointment",
  templateUrl: "./appointment.component.html",
  styleUrls: ["./appointment.component.css"],
})
export class AppointmentComponent implements OnInit {
  appArray = [];
  token: string;
  id: any;
  date4: Date = null;
  isData = false;
  isCross: boolean = false;
  config: { itemsPerPage: number; currentPage: number; totalItems: number };
  totalItems: number = 0;
  page: number = 1;
  clinicData: any;
  clinicArray = [];
  limit :any;
  moment:any=moment;
  constructor(
    private appService: AppointmentService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private appLocalService: AppontmentlocalService,
    private doctorService: DoctorsService
  ) {}

  ngOnInit() {
    this.date4 = new Date();
    this.id = this.activatedRoute.snapshot.queryParams["id"];

    this.authService.authDataSubject.pipe(take(1)).subscribe((auth) => {
      this.token = auth._token;
    });
    this.initConfig();
    this.gelAllClinic();
  }

  getAppointmentOfDoctors(page) {
    this.appService
      .getDoctorAppointment(this.id, this.token, page)
      .subscribe((res) => {
        this.appArray = res.appArray;
        if (this.appArray && this.appArray.length > 0) {
          this.isData = true;
          this.appLocalService.saveAppArray(this.appArray);
          this.page = res.page;
          this.totalItems = res.total;
          this.initConfig();
        }else{
          this.isData = false;
        }
      });
  }
  onSearchAppointment() {
    this.searchAppByDate(this.config.currentPage, this.date4);
  }

  onClearFilter() {
    this.date4 = null;
    this.isCross = false;
    this.appArray = this.appLocalService.getAppArray();
  }

  searchAppByDate(page, appDate) {
    this.appService
      .getDoctorAppointmentByDate(
        appDate,
        this.id,
        this.token,
        page,
        this.clinicData._id
      )
      .subscribe((res) => {
        this.isCross = true;
        this.appArray = res.appArray;
        // this.appArray = this.appArray.filter(o=>o.forWhom != "Others");
        if (this.appArray && this.appArray.length > 0) {
          this.isData = true;
        }else{
          this.isData = false;
        }
        this.page = res.page;
        this.limit = res.limit;
        this.totalItems = res.total;
        this.initConfig();
      });
  }

  initConfig() {
    this.config = {
      itemsPerPage: this.limit,
      currentPage: this.page,
      totalItems: this.totalItems,
    };
  }
  pageChanged(event) {
    this.config.currentPage = event;
    this.searchAppByDate(this.config.currentPage, this.date4);
  }

  onChangeClinic(index) {
    this.clinicData = this.clinicArray[index];
    this.searchAppByDate(this.config.currentPage, this.date4);
  }
  gelAllClinic() {
    this.doctorService.getAllClinic(this.id, this.token).subscribe((res) => {
      this.clinicArray = res.clinics;
      this.clinicData = this.clinicArray[0];
      this.searchAppByDate("1", moment().toDate());
    });
  }
}
